import type { MeDto } from '@system/app/types';

import { AclBuilder } from './aclBuilder';

export const defineAccessFor = (user?: MeDto): AclBuilder => {
  const matrix = new Map<string, string[]>();

  user?.roles.forEach(role => {
    role.rules.forEach(rule => {
      const moduleName: string = rule.module.name;
      const method: string = rule.method;

      if (!rule.disabled) {
        const rules = matrix.has(moduleName)
          ? Array.from(new Set([...(matrix.get(moduleName) ?? []), method]))
          : [method];

        matrix.set(moduleName, rules);
      }
    });
  });

  if (user?.rules && user?.rules.length > 0) {
    user?.rules.forEach(rule => {
      const moduleName: string = rule.module.name;
      const method: string = rule.method;

      if (!rule.disabled) {
        const rules = matrix.has(moduleName)
          ? Array.from(new Set([...(matrix.get(moduleName) ?? []), method]))
          : [method];

        matrix.set(moduleName, rules);
      }
    });
  }

  const ab = new AclBuilder(matrix, {
    isFpk: Boolean(user?.roles.some(role => role.is_fpk)),
    branchId: user?.branch?.entity_id,
    divisionId: user?.division?.id,
  });

  /*
  //! метод для формирования констатны METHODS

  const printReadyObj = () => {
    const arr = Array.from(matrix);
    const entries = Object.fromEntries(arr.map(([key, val]) => [key, val]));
    const obj = {};

    for (const objKey in entries) {
      const items = objEntry[objKey];

      for (const item of items) {
        const spl = item.split('.');
        if (spl[0] === 'classifiers') {
          if (!Reflect.has(obj, objKey)) {
            obj[objKey] = {};
          }

          if (Reflect.has(obj[objKey], spl[1])) {
            Reflect.set(obj[objKey][spl[1]], spl[2], item);
          } else {
            obj[objKey][spl[1]] = {
              [spl[2]]: item,
            };
          }
        } else {
          obj[objKey] = { ...obj[objKey], [spl[1]]: item };
        }
      }
    }

    return obj;
  };
  console.log('\x1b[33m ⚠️ >>>   ', printReadyObj());
   * */

  return ab;

  // can(actions.edit, features.wagonGroupList_item, {
  //   roles: [ROLES.admin, ROLES.officeSpecialist],
  //   status: CarriageGroupStatusesEnum.PENDING,
  // });
  //
  // // Удаление
  // can(actions.delete, features.wagonGroupList_item, {
  //   roles: [ROLES.branchSpecialist],
  //   status: CarriageGroupStatusesEnum.PENDING,
  //   branchId,
  // });
  // can(actions.delete, features.wagonGroupList_item, {
  //   roles: [ROLES.admin, ROLES.officeSpecialist],
  //   status: CarriageGroupStatusesEnum.PENDING,
  // });
  //
  // /** =======================[ Создание группы вагона ]====================== */
  // can(actions.view, features.wagonGroupCreate, {
  //   roles: MODIFIED_ROLES_AND_ADMIN,
  // });
  //
  // /** =======================[ Редактироваине группы вагона ]====================== */
  // can(actions.edit, features.wagonGroupEdit, {
  //   roles: [ROLES.admin, ROLES.officeSpecialist],
  //   status: CarriageGroupStatusesEnum.PENDING,
  // });
  // can(actions.edit, features.wagonGroupEdit, {
  //   roles: [ROLES.branchSpecialist],
  //   status: CarriageGroupStatusesEnum.PENDING,
  //   branchId,
  // });
  //
  // /** =======================[ Перечень поездов ]============================ */
  // // Список
  // can(actions.view, features.trainList, {
  //   roles: ALL_ROLES,
  // });
  // // Выгрузка в Excel
  // can(actions.exportToFile, features.trainList, {
  //   roles: ALL_ROLES,
  // });
  // // Создание
  // can(actions.create, features.trainList_item, {
  //   roles: MODIFIED_ROLES_AND_ADMIN,
  //   status: EAppRouteStatus.StatusPlanning,
  // });
  // // Редактирование
  // can(actions.edit, features.trainList_item, {
  //   roles: [ROLES.branchSpecialist],
  //   branchId,
  // });
  //
  // can(actions.edit, features.trainList_item, {
  //   roles: [ROLES.admin, ROLES.officeSpecialist],
  // });
  //
  // // Удаление
  // can(actions.delete, features.trainList_item, {
  //   roles: [ROLES.branchSpecialist],
  //   branchId,
  // });
  // can(actions.delete, features.trainList_item, {
  //   roles: [ROLES.admin, ROLES.officeSpecialist],
  // });
  //
  // // Согласовать
  // can(actions.agree, features.trainList_item, {
  //   roles: [ROLES.admin, ROLES.officeSpecialist],
  //   isAgree: true,
  // });
  //
  // can(actions.agree, features.trainList_item, {
  //   roles: [ROLES.branchSpecialist],
  //   isAgree: true,
  //   branchId,
  // });
  //
  // // Утвердить
  // can(actions.approve, features.trainList_item, {
  //   roles: [ROLES.admin, ROLES.officeSpecialist],
  // });
  //
  // // Отклонить
  // can(actions.reject, features.trainList_item, {
  //   roles: [ROLES.admin, ROLES.officeSpecialist],
  // });
  // /** ===============[ Создание/Редактироваине заголовка поезда ]============ */
  // can(actions.view, features.trainCreate, {
  //   roles: MODIFIED_ROLES_AND_ADMIN,
  //   status: EAppRouteStatus.StatusPlanning,
  // });
  // /** =======================[ Редактироваине поезда ]====================== */
  // can(actions.edit, features.trainEdit, {
  //   roles: [ROLES.branchSpecialist],
  //   branchId,
  // });
  // can(actions.edit, features.trainEdit, {
  //   roles: [ROLES.admin, ROLES.officeSpecialist],
  // });
  //
  // /** =======================[ Администратор ]====================== */
  // can(actions.view, features.admin, {
  //   roles: [ROLES.admin],
  // });
  //
  // /** =======================[ Классификаторы ]====================== */
  // can(actions.create, features.carriageAdditionalSeatsSigns, {
  //   roles: [ROLES.admin, ROLES.officeSpecialist],
  // });
  // can(actions.create, features.carriageSeatsAllocations, {
  //   roles: [ROLES.admin, ROLES.officeSpecialist],
  // });
  // can(actions.create, features.stations, {
  //   roles: [ROLES.admin, ROLES.officeSpecialist],
  // });
  // can(actions.create, features.railways, {
  //   roles: [ROLES.admin, ROLES.officeSpecialist],
  // });
  // can(actions.create, features.railwayAdministration, {
  //   roles: [ROLES.admin, ROLES.officeSpecialist],
  // });
  //
  // can(actions.create, features.passengerCarriersRussianRailway, {
  //   roles: [ROLES.admin, ROLES.officeSpecialist],
  // });
  //
  // can(actions.create, features.branches, {
  //   roles: [ROLES.admin, ROLES.officeSpecialist],
  // });
  //
  // can(actions.create, features.structuralSubdivisions, {
  //   roles: [ROLES.admin, ROLES.officeSpecialist],
  // });
  //
  // can(actions.create, features.trainCategory, {
  //   roles: [ROLES.admin, ROLES.officeSpecialist],
  // });
  //
  // can(actions.create, features.carriageTypesAsu, {
  //   roles: [ROLES.admin, ROLES.officeSpecialist],
  // });
  //
  // can(actions.create, features.mvpsMartinSectionTypes, {
  //   roles: [ROLES.admin, ROLES.officeSpecialist],
  // });
  // can(actions.create, features.mvpsCompanyAffiliations, {
  //   roles: [ROLES.admin, ROLES.officeSpecialist],
  // });
  //
  // can(actions.create, features.carriageTypes, {
  //   roles: [ROLES.admin, ROLES.officeSpecialist],
  // });
  // can(actions.create, features.carriageDimensions, {
  //   roles: [ROLES.admin, ROLES.officeSpecialist],
  // });
  // can(actions.create, features.carriageLength, {
  //   roles: [ROLES.admin, ROLES.officeSpecialist],
  // });
  // can(actions.create, features.carriageServiceClasses, {
  //   roles: [ROLES.admin, ROLES.officeSpecialist],
  // });
  // can(actions.create, features.nonPassengerCarriageTypes, {
  //   roles: [ROLES.admin, ROLES.officeSpecialist],
  // });
  // can(actions.create, features.carriageBrakeType, {
  //   roles: [ROLES.admin, ROLES.officeSpecialist],
  // });
  // can(actions.create, features.carriageHeatType, {
  //   roles: [ROLES.admin, ROLES.officeSpecialist],
  // });
  // can(actions.create, features.carriageModel, {
  //   roles: [ROLES.admin, ROLES.officeSpecialist],
  // });
  // can(actions.create, features.transportationPerformanceIndicators, {
  //   roles: [ROLES.admin, ROLES.officeSpecialist],
  // });
  // can(actions.create, features.trainBrand, {
  //   roles: [ROLES.admin, ROLES.officeSpecialist],
  // });
  // can(actions.create, features.carriageTypesForSchema, {
  //   roles: [ROLES.admin, ROLES.officeSpecialist],
  // });
  //
  // /** =======================[ ПБГ ]====================== */
  // // Список
  // can(actions.view, features.trailedDirectGroupList, {
  //   roles: ALL_ROLES,
  // });
  //
  // // создание
  // can(actions.create, features.trailedDirectGroupCreate, {
  //   roles: MODIFIED_ROLES_AND_ADMIN,
  //   status: EAppRouteStatus.StatusPlanning,
  // });
  //
  // // Выгрузка в Excel
  // can(actions.exportToFile, features.trailedDirectGroupList, {
  //   roles: ALL_ROLES,
  // });
  //
  // // Удаление
  // can(actions.delete, features.trailedDirectGroupList_item, {
  //   roles: [ROLES.branchSpecialist],
  //   branchId,
  // });
  // can(actions.delete, features.trailedDirectGroupList_item, {
  //   roles: [ROLES.admin, ROLES.officeSpecialist],
  // });
};
